import { __decorate } from "tslib";
import AppBar from "@/components/AppBar.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import AppBarResponsiveButton from "@/components/AppBarResponsiveButton.vue";
let ContactEditAppBar = class ContactEditAppBar extends Vue {
    loading;
    error;
    finished;
    appBarTitle;
    onSaveContact() {
        this.$emit('onSave');
    }
};
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ContactEditAppBar.prototype, "loading", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ContactEditAppBar.prototype, "error", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ContactEditAppBar.prototype, "finished", void 0);
__decorate([
    Prop({ type: String, required: false, default: "" })
], ContactEditAppBar.prototype, "appBarTitle", void 0);
ContactEditAppBar = __decorate([
    Component({
        components: {
            AppBar,
            AppBarResponsiveButton
        },
    })
], ContactEditAppBar);
export default ContactEditAppBar;
